import { t } from "@i18n";
import TextFieldComponent from "@CubeComponents/Mui_Form/TextFieldComponent";
import AutoComplete from "@CubeComponents/Mui_Form/AutoComplete";
const useCustomFields = () => {
  const validateFormWithId = (id: any, template: any, formValidator: any) => {
    const rules: any[] = [];
    if (!template || !template.length) {
      return true;
    }
    template?.forEach((section: any) => {
      section.questionFields.forEach((item: any) => {
        rules.push({ name: `${id}_${item._id}`, value: item.answer?.value });
      });
    });
    let valid = true;
    rules.forEach((rule: any) => {
      const ruleValid = formValidator?.validate({
        name: rule.name,
        value: rule.value,
      });
      valid = valid && ruleValid;
    });
    return valid;
  };

  return {
    validateFormWithId,
  };
};

export const getNomenclatureFieldWidthPx = (field: any) => {
  if (field?.type === "single select") return 200;
  const allowed = Number(field?.allowedCharacters) || 0;
  return Math.max(110, allowed * 10 + 28);
};

export const getNomenclatureFieldWidth = (field: any) => `${getNomenclatureFieldWidthPx(field) / 16}rem`;

export const NomenclatureField = ({ args, field, index, value, handleNomenclatureChange }: any) => {
  if (field.type == "text" || field.type == "number") {
    const char = field.type == "text" ? "A" : "1";
    const placeholderText = field.allowedCharacters ? char.repeat(field.allowedCharacters) : `${char.repeat(3)}...`;
    const htmlAttributes: any = {};
    if (field.allowedCharacters) {
      htmlAttributes.maxlength = `${field.allowedCharacters}`;
    }
    const allowedPattern = field.type == "text" ? /^[A-Za-z]*$/ : /^[0-9]*$/;
    const handleChange = (e: any) => {
      const newValue = e.target.value;
      const maxLength = field.allowedCharacters;
      if (maxLength && newValue.length > maxLength) {
        return;
      }
      if (newValue !== "" && !allowedPattern.test(newValue)) {
        return;
      }
      handleNomenclatureChange(e, args, field, index);
    };

    return (
      <div className="shrink-0" style={{ width: getNomenclatureFieldWidth(field) }}>
        <TextFieldComponent
          id={`${args.id}-${field.type}-${index}`}
          type="text"
          onClick={(e: React.SyntheticEvent) => e.stopPropagation()}
          value={value}
          placeholder={placeholderText}
          slotProps={{
            htmlInput: {
              maxLength: field.allowedCharacters,
              inputMode: field.type == "number" ? "numeric" : "text",
            },
          }}
          onChange={handleChange}
        />
      </div>
    );
  }
  if (field.type == "single select") {
    // field.options can be array of strings or array of {text, value} objects
    const isStringArray = field.options?.length > 0 && typeof field.options[0] === "string";

    return (
      <div className="shrink-0" style={{ width: getNomenclatureFieldWidth(field) }}>
        <AutoComplete
          id={`${args.id}-${field.type}-${index}`}
          key={`${args.id}-${field.type}-${index}`}
          width="100%"
          options={field.options || []}
          valueField={isStringArray ? undefined : "value"}
          getOptionLabel={(option: any) => {
            if (typeof option === "string") return option;
            return option?.text || "";
          }}
          value={value}
          onChange={(_event: any, newValue: any) => {
            const selectedValue = typeof newValue === "string" ? newValue : newValue?.value;
            handleNomenclatureChange({ target: { value: selectedValue ?? "" } }, args, field, index);
          }}
          renderInput={(params: any) => <TextFieldComponent {...params} placeholder={t("Select an option")} />}
        />
      </div>
    );
  }
};
export const getNomenclatureField = (args: any, field: any, index: any, value: any, handleNomenclatureChange: any) => (
  <NomenclatureField
    args={args}
    field={field}
    index={index}
    value={value}
    handleNomenclatureChange={handleNomenclatureChange}
  />
);

NomenclatureField.defaultProps = {
  value: "",
};
export default useCustomFields;
